/* =========================================================
   LAWRENCE — Founder’s Batch: require dropdown selections
   Blocks Add to Cart until all selects inside .lawrence-customizer are chosen
========================================================= */
(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function isEmptyValue(v) {
    if (v == null) return true;
    const s = String(v).trim();
    return (
      s === "" ||
      s.toLowerCase() === "select one" ||
      s.toLowerCase() === "select" ||
      s === "—"
    );
  }

  function setupCustomizer(fieldset) {
    const form =
      fieldset.closest('form[action*="/cart/add"]') ||
      fieldset.closest("product-form") ||
      fieldset.closest("form");

    if (!form) return;

    const selects = Array.from(fieldset.querySelectorAll("select"));
    if (!selects.length) return;

    const addBtn =
      form.querySelector('button[name="add"]') ||
      form.querySelector('button[type="submit"]');

    const shopPayWrap = form.querySelector(".shopify-payment-button");
    const shopPayBtns = shopPayWrap
      ? Array.from(shopPayWrap.querySelectorAll("button, [role='button'], a"))
      : [];

    // Create/ensure an inline error message container
    let msg = fieldset.querySelector(".lawrence-customizer__error");
    if (!msg) {
      msg = document.createElement("div");
      msg.className = "lawrence-customizer__error";
      msg.setAttribute("role", "alert");
      msg.setAttribute("aria-live", "polite");
      fieldset.prepend(msg);
    }

    function getMissing() {
      return selects.filter((sel) => isEmptyValue(sel.value));
    }

    function setDisabled(disabled) {
      if (addBtn) {
        addBtn.disabled = !!disabled;
        addBtn.setAttribute("aria-disabled", disabled ? "true" : "false");
      }

      // Disable accelerated checkout until valid
      if (shopPayWrap) {
        shopPayWrap.style.pointerEvents = disabled ? "none" : "";
        shopPayWrap.style.opacity = disabled ? "0.45" : "";
      }

      shopPayBtns.forEach((b) => {
        b.setAttribute("aria-disabled", disabled ? "true" : "false");
      });
    }

    function clearErrors() {
      selects.forEach((sel) => sel.classList.remove("lawrence-is-invalid"));
      fieldset.classList.remove("lawrence-has-errors");
      msg.textContent = "";
    }

    function showErrors() {
      const missing = getMissing();
      clearErrors();

      if (!missing.length) return true;

      fieldset.classList.add("lawrence-has-errors");
      missing.forEach((sel) => sel.classList.add("lawrence-is-invalid"));
      msg.textContent =
        "Please select your system, sleeve option, and size before adding to cart.";

      // Scroll + focus first missing
      const first = missing[0];
      try {
        first.scrollIntoView({ behavior: "smooth", block: "center" });
      } catch (e) {}
      try {
        first.focus({ preventScroll: true });
      } catch (e) {}

      return false;
    }

    function updateState() {
      const missing = getMissing();
      setDisabled(missing.length > 0);
      if (missing.length === 0) clearErrors();
    }

    // Block submit (covers enter key, form submission, AJAX handlers)
    form.addEventListener(
      "submit",
      function (e) {
        if (!showErrors()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          updateState();
          return false;
        }
      },
      true
    );

    // Block direct click (covers themes that bypass submit)
    if (addBtn) {
      addBtn.addEventListener(
        "click",
        function (e) {
          if (!showErrors()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            updateState();
            return false;
          }
        },
        true
      );
    }

    // Block dynamic checkout click as well
    if (shopPayWrap) {
      shopPayWrap.addEventListener(
        "click",
        function (e) {
          if (getMissing().length > 0) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            showErrors();
            updateState();
            return false;
          }
        },
        true
      );
    }

    // Re-check on any change
    selects.forEach((sel) => sel.addEventListener("change", updateState));

    // Initial state: disable until complete
    updateState();
  }

  ready(function () {
    document
      .querySelectorAll("fieldset.lawrence-customizer")
      .forEach(setupCustomizer);
  });
})();
